var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5 3.75H4.5C3.39543 3.75 2.5 4.64543 2.5 5.75V15.5C2.5 16.6046 3.39543 17.5 4.5 17.5H15.5C16.6046 17.5 17.5 16.6046 17.5 15.5V5.75C17.5 4.64543 16.6046 3.75 15.5 3.75Z",
    stroke: "#404055",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.5 7.62988H17.5",
    stroke: "#404055",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.82031 2.5V4.99",
    stroke: "#404055",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.1602 2.5V4.99",
    stroke: "#404055",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.446ef0373d444161afcd676a11f6fc03.svg";
export { ForwardRef as ReactComponent };